module.exports = __webpack_public_path__ + "img/m4.f4fbba8b.svg";